<template>
  <div class="breadcrump-wrapper">
    <v-breadcrumbs
      large
      :items="[{ text: local.breadcrumbs.home, to: '/' }, ...breadcrumbs.data]"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'NajBreadcrumb',
  computed: {
    ...mapState(['breadcrumbs']),
    ...mapGetters(['finalRoutes']),
    params() {
      return this.breadcrumbs.params;
    },
    formattedValue(route) {
      return route.meta.breadcrumbs.linkText(this.value);
    },
    loadingText(route) {
      const loadingText = route.meta.breadcrumbs.loadingText;
      return loadingText || 'Loading...';
    },
  },
  methods: {
    ...mapActions(['clearBreadcrumbsData', 'updateBreadcrumbs']),
    getRouteGetter(route) {
      if (route.meta.breadcrumbs.getter) {
        return this.$store.getters[route.meta.breadcrumbs.getter];
      } else {
        return null;
      }
    },
    returnUrlPathArray(path) {
      return path
        .replace(/\//g, ':')
        .split(':')
        .filter(item => item);
    },
    isValidNodeId(nodeId) {
      return this.finalRoutes.find(item => item.id == nodeId);
    },
    replaceParamsWithValues(path) {
      const urlArray = this.returnUrlPathArray(path);
      const lastParam = this.$route.params[urlArray[urlArray.length - 1]];
      if (!isNaN(lastParam) && !this.isValidNodeId(lastParam)) {
        return '#';
      }
      const url = urlArray
        .map((item) => {
          return this.$route.params[item] ? this.$route.params[item] : item;
        })
        .join('/');
      return '/' + url;
    },
    prepareBreadcrumbs(matchedRoutes) {
      const currentRoute = this.$route;
      matchedRoutes.reduce((breadcrumbs, route) => {
        const breadcrumbsMeta = route.meta.breadcrumbs;
        let text = null;
        let to = null;
        const pathArray = route.path.split('/');
        const paramName = Object.keys(currentRoute.params).length
          ? pathArray[pathArray.length - 1].replace(':', '')
          : null;
        if (breadcrumbsMeta) {
          to = this.replaceParamsWithValues(route.path);
          text =
            breadcrumbsMeta.text ||
            this.$store.getters[breadcrumbsMeta.getter](currentRoute.params[paramName]);
          this.updateBreadcrumbs({
            params: currentRoute.params,
            data: {
              exact: true,
              text,
              to,
              disabled: to == '#',
              getter: breadcrumbsMeta.getter,
            },
          });
          return breadcrumbs.concat({
            exact: true,
            text,
            to,
            disabled: to == '#',
            getter: breadcrumbsMeta.getter,
          });
        }
        return breadcrumbs;
      }, []);
    },
  },
  watch: {
    $route(newRoute) {
      this.clearBreadcrumbsData();
      this.prepareBreadcrumbs(newRoute.matched);
    },
  },
  mounted() {
    this.clearBreadcrumbsData();
    this.prepareBreadcrumbs(this.$route.matched);
  },
};
</script>
<style lang="scss">
.breadcrump-wrapper {
  display: inline-block;
  direction: ltr;
  line-height: 1;
  .v-breadcrumbs {
    & > li {
      &.v-breadcrumbs__divider {
        color: #98a6ad;
        font-weight: bold;
      }

      & > a.v-breadcrumbs__item.v-breadcrumbs__item--disabled {
        color: #6c757d;
        opacity: 1;
      }
      & > a.v-breadcrumbs__item {
        font-size: 1rem;
        color: #6c757d;
        opacity: 0.5;
        @media (max-width: 1680px) {
          font-size: 17px;
        }
      }
    }
  }
}
</style>
